<section class="tw-w-full tw-flex tw-flex-col tw-basis-full tw-h-full place-content-stretch ">
    <section class="tw-flex tw-flex-col tw-basis-full tw-w-full tw-items-start tw-p-2">
        <section class="tw-flex tw-h-full tw-flex-row tw-basis-full tw-w-full">
            <section class="tw-flex tw-flex-col tw-h-full tw-w-[25%] tw-justify-self-stretch" >
                <p-card class="tw-w-full tw-m-[2.0%] tw-p-0">
                    <app-document-type-common #docTypeForm [(documentTypeId)]="documentTypeId" (documentTypeAdded)="commonAddEvent($event)"
                        (documentTypeRemoved)="commonRemoveEvent()" (areaConfigChange)="updateFunctionalAreas($event)"></app-document-type-common>
                </p-card>

            </section>
            <p-divider layout="vertical" styleClass="tw-h-1"></p-divider>
            <div class="tw-w-[70%] tw-h-[81vh] tw-overflow-y-auto">
                <p-tabView [activeIndex]="0" styleClass="tw-h-full tw-w-full">

                    <p-tabPanel [disabled]="!docTypeForm.functionalAreasConfig.elynk">
                        <ng-template pTemplate="header">
                            <section class="header-title">
                                <span class="vertical-align-middle"><strong>eLynk</strong></span>
                            </section>
                        </ng-template>

                        <section>
                            <section class="tw-flex tw-flex-col tw-p-2 tw-mb-4 tw-ml-4">
                                <section class="tw-w-full">
                                    <section class="tw-flex tw-flex-col tw-p-2 tw-mb-4 tw-ml-4">
                                        <app-elynk #elynk [documentTypeId]="documentTypeId" [active]="docTypeForm.functionalAreasConfig.elynk"></app-elynk>
                                    </section>
                                </section>
                            </section>
                        </section>
                    </p-tabPanel>

                    <p-tabPanel [disabled]="!docTypeForm.functionalAreasConfig.templateManager">
                        <ng-template pTemplate="header">
                            <section class="header-title">
                                <span class="vertical-align-middle"><strong>Templates</strong></span>
                            </section>
                        </ng-template>
                        <section>
                            <section class="tw-flex tw-flex-col tw-p-2 tw-mb-4 tw-ml-4">
                                <div class="tw-w-full">
                                    <app-template-mgr #templateMgr [documentTypeId]="documentTypeId" [active]="docTypeForm.functionalAreasConfig.templateManager"></app-template-mgr>
                                </div>
                            </section>
                        </section>
                    </p-tabPanel>

                    <p-tabPanel class="tw-h-full tw-bg-stone-400" [disabled]="!docTypeForm.functionalAreasConfig.documentClassification">
                        <ng-template pTemplate="header">
                            <section class="header-title">
                                <span class="vertical-align-middle tsd"><strong>Document Classification</strong></span>
                            </section>
                        </ng-template>
                        <section >
                            <section class="tw-flex tw-flex-col tw-p-2 tw-mb-4 tw-ml-4">
                                <div class="tw-w-full">
                                    <app-doctype-class #classification [documentTypeId]="documentTypeId" [active]="docTypeForm.functionalAreasConfig.documentClassification"></app-doctype-class>
                                </div>
                            </section>
                        </section>
                    </p-tabPanel>
                </p-tabView>
            </div>
        </section>
    </section>

</section>
